import apiRequest from "../../helpers/apiRequest";
import { AxiosResponse } from "axios";

export default async function getUserById(id: string) {
    const userInfo = await apiRequest.get(`/user/${id}`).then((res: AxiosResponse) => res.data);

    return userInfo;
}
